/**
 * The ACNG frontend stores data in the browser.
 *
 * @module
 *
 * @see [Web Storage API - MDN](https://developer.mozilla.org/docs/Web/API/Web_Storage_API)
 */

import {make} from '../core/service/env.js';
import {LocalStore, SessionStore} from 'nova';

/**
 * @import {LocalStorageData, SessionStorageData} from './d.ts/browser-storage';
 */

/** @internal @type {Partial<LocalStorageData>} */
export const localStore = make(LocalStore);
export const USER_IMAGE_CROP = 'userImageCrop';
export const FSK_DISCLAIMER_DONE = 'fskDisclaimerDone';
export const LEGAL_AGE_CONFIRMATION_CLICKED = 'legalAgeConfirmationClicked';
export const PROFILE_VISITS = 'profileVisits';
export const HOTORNOT_TIMER_EXPIRE = 'hotornot-timer-expire';
export const HOTORNOT_LIST = 'hotornot-timer-list';
export const POSITIVE_VOTE_IMAGES = 'positiveVoteImages';

/** @internal @type {Partial<SessionStorageData>} */
export const sessionStore = make(SessionStore);
export const TRANSACTION_DETAILS = 'transactionDetails';
export const PAYBACK_DETAILS = 'paybackDetails';
export const NOTIFICATION_REQUESTED = 'notification-requested';
export const USER_PROFILE = 'userProfile';
